import clsx from "clsx";

type ProfileDetailsLoaderVariant = "customer" | "pet";

type ProfileDetailsLoaderProps = {
  variant: ProfileDetailsLoaderVariant;
  className?: string;
};

const PLACEHOLDERS: Record<ProfileDetailsLoaderVariant, string[]> = {
  customer: ["w-48", "max-w-[480px]", "max-w-[780px]"],
  pet: ["w-36", "max-w-[280px]", "max-w-[320px]"],
};

const ProfileDetailsLoader: React.FC<ProfileDetailsLoaderProps> = ({ variant, className }) => {
  const [headline, ...lines] = PLACEHOLDERS[variant];
  const skeletonBgStyle = { backgroundColor: "var(--color-neutral-quaternary, #d1d5db)" };

  return (
    <div
      role="status"
      className={clsx(
        "space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center",
        className,
      )}
    >
      <div className="w-full">
        <div className={clsx("h-2 rounded-full mb-2", headline)} style={skeletonBgStyle} />
        {lines.map((lineClass, index) => (
          <div
            key={`${variant}-loader-line-${index}`}
            className={clsx("h-2 rounded-full mb-2", lineClass)}
            style={skeletonBgStyle}
          />
        ))}
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default ProfileDetailsLoader;
